export * from './esri4-map.service';
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
